<template>
  <ListView
    modelName="Price"
    perm="master.menu_price"
    :items.sync="items"
    :params.sync="params"
    title="menu_price"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="Price"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    :comparer="(a,b)=>a.id == b.id"        
    tooltip="単価マスタを登録すると、受注明細や発注明細で商品を選択した際に、自動で単価が設定されるようになります。SKU・単位(荷姿)・取引先単価区分別の単価設定も可能です。<br><br>※販売側で単価マスタを使用する場合は、商品マスタの【販売単価区分】で【単価マスタ】を指定してください。"
    :popup="popup"
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="masterBaseStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow" :perm="$refs.mainList.perm+'.approve'"/></GridItem>    
    <GridItem :slot="listSlots[2]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.id }}</GridItem>
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.commodity.code }}</GridItem>    
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{  item.sku == null ? "" : item.sku.name }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.commodity.manufacturer }}</GridItem>  
    <GridItem :slot="listSlots[7]" slot-scope="{ item }">{{ item.commodity.model }}</GridItem>       
    <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.priceType | priceTypes }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.currency | currency }}</GridItem>    
    <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.price }}</GridItem>
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.conversion.name }}</GridItem>
    <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.tax | taxCode }}</GridItem>
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.counterpart?item.counterpart.name:'' }}</GridItem>
    <GridItem :slot="listSlots[14]" slot-scope="{ item }">{{ item.counterpartPriceCategory | category_101 }}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ item.startDate | date }}</GridItem>
    <!-- <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ item.commodityId | commodityCode }}</GridItem>     -->
    <!-- <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.minimumQuantity1 }}</GridItem>
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.price1 }}</GridItem>
    <GridItem :slot="listSlots[14]" slot-scope="{ item }">{{ item.minimumQuantity2 }}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ item.price2 }}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.minimumQuantity3 }}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.price3 }}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.minimumQuantity4 }}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.price4 }}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.minimumQuantity5 }}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }">{{ item.price5 }}</GridItem>
    <GridItem :slot="listSlots[22]" slot-scope="{ item }">{{ item.minimumQuantity6 }}</GridItem>
    <GridItem :slot="listSlots[23]" slot-scope="{ item }">{{ item.price6 }}</GridItem>
    <GridItem :slot="listSlots[24]" slot-scope="{ item }">{{ item.minimumQuantity7 }}</GridItem>
    <GridItem :slot="listSlots[25]" slot-scope="{ item }">{{ item.price7 }}</GridItem>
    <GridItem :slot="listSlots[26]" slot-scope="{ item }">{{ item.minimumQuantity8 }}</GridItem>
    <GridItem :slot="listSlots[27]" slot-scope="{ item }">{{ item.price8 }}</GridItem>
    <GridItem :slot="listSlots[28]" slot-scope="{ item }">{{ item.minimumQuantity9 }}</GridItem>
    <GridItem :slot="listSlots[29]" slot-scope="{ item }">{{ item.price9 }}</GridItem> -->
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView">
        <ListViewMenu slot="file_layout_download" icon="file_download" title="インポートファイル"  @click="$api.fileDownload('https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E5%8D%98%E4%BE%A1%E3%83%9E%E3%82%B9%E3%82%BF%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx')" tooltip="単価情報インポート用のレイアウトファイルをダウンロードします。" />
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView">
        <!-- <FilterBox title="商品コード" :value.sync="params.commodityCode" @click="handler" />         -->
        <!-- <FilterBox title="商品名称" :value.sync="params.commodityName" @click="handler" /> -->
        <!-- <FilterBox title="SKUコード" :value.sync="params.skuCode" @click="handler" />         -->
        <FilterBox title="商品コード" :value.sync="params.code" @click="handler" />
        <FilterBox title="メーカー" :value.sync="params.manufacturer" @click="handler" />        
        <FilterBox title="型番" :value.sync="params.model" @click="handler" />        
        <ComboBox title="単価区分" :value.sync="params.priceType" list="priceTypes" @changed="handler" />
        <ComboBox title="表示区分" :value.sync="params.priceDisplayType" list="priceDisplayTypes" @changed="handler" />
        <AtcCounterpart title="取引先" :value.sync="params.counterpart" :needsCustomer="true" :needsSupplier="true" @changed="handler"/>
        <AutoComplete title="取引先単価区分" :value.sync="params.counterpartPriceCategory" list="category_101" @changed="handler" />
        <AutoComplete title="通貨" :value.sync="params.currency" list="currency" @changed="handler" />
        <AtcCommodity title="商品" :value.sync="params.commodity" @changed="handler" />
        <AtcSKU title="SKU" :value.sync="params.sku" :commodity="params.commodity" @update:value="handler" />                 
        <Calendar title="価格改定日(From)" :value.sync="params.startDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="価格改定日(To)" :value.sync="params.startDateTo" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />         
        <ComboBox title="状態" :value.sync="params.state" list="masterBaseStatus" @changed="handler" />        
      </Search>
    </template>
    <!-- エディタの配置 -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','数量別単価','ワークフロー','更新履歴']" :tabTooltips="[null,null,null,null]">
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">              
              <NumericBox title="ID" :value.sync="item.id" :editor="editor" :enabled="false" tooltip="単価を管理するためのID(自動採番)が表示されます。"/>
              <AtcCommodity title="商品" :value.sync="item.commodity" :enabled="listView.isInsertMode && popup ==null"  :editor="editor" :required="true" :linkOnNewTab="false" @update:value="checkPriceType(item)" tooltip="単価を登録する商品を指定します。"/>
              <AtcSKU title="SKU" :value.sync="item.sku" :editor="editor" :commodity="item.commodity" :nullValue="''" tooltip="SKUによって単価が異なる場合は、SKUを指定してください。"/>
              <ComboBox title="単価区分" :value.sync="item.priceType" :editor="editor" list="priceTypes" :required="true" :isDirectEditEnabled="false" :showDefault="false" @update:value="checkPriceType(item)" tooltip="仕入単価、販売単価のどちらに適用するかを指定します。"/>
              <AutoComplete title="通貨" :value.sync="item.currency" :editor="editor" list="currency" :required="true" v-if="hasLicenseCurrency"/>              
              <NumericBox title="標準単価" :value.sync="item.price" :editor="editor" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="0" max="999999999.999999" tooltip="単価を指定します。"/>
              <AtcConversion title="単位" :value.sync="item.conversion2" :editor="editor" :required="true" :commodity="item.commodity" :nullValue="''" tooltip="単価の単位を指定します。荷姿に対して単価を設定することもできます。"/>
              <AtcTaxCode title="税区分" :editor="editor" :value.sync="item.tax" list="taxCode" :required="true" tooltip="単価の税区分を指定します。【税区分マスタ】に登録されているデータから選択できます。"/>
              <AtcCounterpart title="取引先" :value.sync="item.counterpart" :editor="editor"  :needsCustomer="item.priceType==1" :needsSupplier="item.priceType==2" :enabled="!item.counterpartPriceCategory" :isDirectEditEnabled="false" tooltip="単価を反映する取引先を指定します。販売単価の場合得意先、仕入単価の場合仕入先が指定できます。"/>
              <AutoComplete title="取引先単価区分" :value.sync="item.counterpartPriceCategory" :editor="editor" list="category_101" :enabled="!item.counterpart" :isDirectEditEnabled="false" path="/master/Category" tooltip="取引先単価区分を指定すると、特定の取引先に単価が適用されます。<br>※適用したい取引先にも同じ取引先単価区分を指定する必要があります。<br>※【取引先単価区分】は【<a href='/master/Category' target='_blank'>区分一覧</a>】で登録することができます。"/>
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <Calendar title="価格改定日" :value.sync="item.startDate" :editor="editor" :deletable="true" tooltip="価格改定日を指定すると、指定日以降の受注・発注に対して単価が適用されます。"/>
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="最後に更新した日付が表示されます。"/>                      
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_masterBase" :required="$api.perms.hasWorkflow('masterBase')" :enabled="$api.perms.hasWorkflow('masterBase') && $api.perms.isEntryStatus(item)" :nullValue="0" tooltip="マスタ登録用のワークフローを指定します。"/>
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="ワークフローの現在の状態が表示されています。"/>             
            </template>
          </EditPanel>
        </template>
        <!-- 数量別単価タブ -->
        <template slot="tab1" slot-scope="{ item, editor }">
            <EditPanel>
            <template slot="left">
              <NumericBox title="適用数量1" :value.sync="item.minimumQuantity1" :editor="editor" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="0" max="99999999.999" />
              <NumericBox title="適用単価1" :value.sync="item.price1" :editor="editor" :enabled="enabledPrice(1, item)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="0" max="999999999.999999" :nullValue="0" tooltip="適用数量1以上の場合に使用されます。"/>
              <NumericBox title="適用数量2" :value.sync="item.minimumQuantity2" :editor="editor" :enabled="enabledPrice(1, item)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="0" max="99999999.999" :nullValue="0" />
              <NumericBox title="適用単価2" :value.sync="item.price2" :editor="editor" :enabled="enabledPrice(2, item)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="0" max="999999999.999999" :nullValue="0" tooltip="適用数量2以上の場合に使用されます。"/>
              <NumericBox title="適用数量3" :value.sync="item.minimumQuantity3" :editor="editor" :enabled="enabledPrice(2, item)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="0" max="99999999.999" :nullValue="0" />
              <NumericBox title="適用単価3" :value.sync="item.price3" :editor="editor" :enabled="enabledPrice(3, item)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="0" max="999999999.999999" :nullValue="0" tooltip="適用数量3以上の場合に使用されます。"/>
              <NumericBox title="適用数量4" :value.sync="item.minimumQuantity4" :editor="editor" :enabled="enabledPrice(3, item)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="0" max="99999999.999" :nullValue="0" />
              <NumericBox title="適用単価4" :value.sync="item.price4" :editor="editor" :enabled="enabledPrice(4, item)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="0" max="999999999.999999" :nullValue="0" tooltip="適用数量4以上の場合に使用されます。"/>
              <NumericBox title="適用数量5" :value.sync="item.minimumQuantity5" :editor="editor" :enabled="enabledPrice(4, item)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="0" max="99999999.999" :nullValue="0" />
              <NumericBox title="適用単価5" :value.sync="item.price5" :editor="editor" :enabled="enabledPrice(5, item)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="0" max="999999999.999999" :nullValue="0" tooltip="適用数量5以上の場合に使用されます。"/>
            </template>
            <template slot="right">
              <NumericBox title="適用数量6" :value.sync="item.minimumQuantity6" :editor="editor" :enabled="enabledPrice(5, item)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="0" max="99999999.999" :nullValue="0" />
              <NumericBox title="適用単価6" :value.sync="item.price6" :editor="editor" :enabled="enabledPrice(6, item)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="0" max="999999999.999999" :nullValue="0" tooltip="適用数量6以上の場合に使用されます。"/>
              <NumericBox title="適用数量7" :value.sync="item.minimumQuantity7" :editor="editor" :enabled="enabledPrice(6, item)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="0" max="99999999.999" :nullValue="0" />
              <NumericBox title="適用単価7" :value.sync="item.price7" :editor="editor" :enabled="enabledPrice(7, item)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="0" max="999999999.999999" :nullValue="0" tooltip="適用数量7以上の場合に使用されます。"/>
              <NumericBox title="適用数量8" :value.sync="item.minimumQuantity8" :editor="editor" :enabled="enabledPrice(7, item)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="0" max="99999999.999" :nullValue="0" />
              <NumericBox title="適用単価8" :value.sync="item.price8" :editor="editor" :enabled="enabledPrice(8, item)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="0" max="999999999.999999" :nullValue="0" tooltip="適用数量8以上の場合に使用されます。"/>
              <NumericBox title="適用数量9" :value.sync="item.minimumQuantity9" :editor="editor" :enabled="enabledPrice(8, item)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" min="0" max="99999999.999" :nullValue="0" />
              <NumericBox title="適用単価9" :value.sync="item.price9" :editor="editor" :enabled="enabledPrice(9, item)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" min="0" max="999999999.999999" :nullValue="0" tooltip="適用数量9以上の場合に使用されます。"/>
              </template>              
            </EditPanel>
        </template>        
        <!-- ワークフロータブ -->
        <template slot="tab2" slot-scope="{ item, editor }">
          <MessageList class="cx_matter_message" :item="item" :editor="editor" />
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab3" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo"/>
        </template>
      </Editor>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PriceView extends Vue {
  public items: Common.Price[] = new Array(0);
  public params: Common.PriceQuery = new Common.PriceQuery();
  public importQuery = new Common.PriceImportQuery('単価');
  public exportQuery = new Common.PriceExportQuery('単価', this.params);
  public tenantSettings: Common.TenantSettings = new Common.TenantSettings();
  public hasLicenseCurrency: boolean = false;
  @Prop() public auditNo:string;
  @Prop() public commodityCode:string;
  @Prop() public commodity:Common.Commodity;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([], 6, 'grid');


  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'commodity', text: '商品' },
    { value: 'tax', text: '税区分' },
    { value: 'counterpartPriceCategory', text: '取引先単価区分' },
    { value: 'startDate', text: '価格改定日' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  public created() {
    //テナント設定をロードする
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('ID', 100),
      new Common.GridItemConfiguration('商品コード', 150),      
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('メーカー', 100),      
      new Common.GridItemConfiguration('型番', 100),       
      new Common.GridItemConfiguration('単価区分', 100),
      new Common.GridItemConfiguration('通貨', 80,this.hasLicenseCurrency),          
      new Common.GridItemConfiguration('標準単価', 120),
      new Common.GridItemConfiguration('単位', 100),
      new Common.GridItemConfiguration('税区分', 100),      
      new Common.GridItemConfiguration('取引先', 120),
      new Common.GridItemConfiguration('取引先単価区分', 120),
      new Common.GridItemConfiguration('価格改定日', 120),      
      // new Common.GridItemConfiguration('商品コード', 150),      
      // new Common.GridItemConfiguration('適用数量1', 150),
      // new Common.GridItemConfiguration('適用単価1', 150),
      // new Common.GridItemConfiguration('適用数量2', 150),
      // new Common.GridItemConfiguration('適用単価2', 150),
      // new Common.GridItemConfiguration('適用数量3', 150),
      // new Common.GridItemConfiguration('適用単価3', 150),
      // new Common.GridItemConfiguration('適用数量4', 150),
      // new Common.GridItemConfiguration('適用単価4', 150),
      // new Common.GridItemConfiguration('適用数量5', 150),
      // new Common.GridItemConfiguration('適用単価5', 150),
      // new Common.GridItemConfiguration('適用数量6', 150),
      // new Common.GridItemConfiguration('適用単価6', 150),
      // new Common.GridItemConfiguration('適用数量7', 150),
      // new Common.GridItemConfiguration('適用単価7', 150),
      // new Common.GridItemConfiguration('適用数量8', 150),
      // new Common.GridItemConfiguration('適用単価8', 150),
      // new Common.GridItemConfiguration('適用数量9', 150),
      // new Common.GridItemConfiguration('適用単価9', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150)
    );


    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }
      
    if (this.commodity){
      this.params.commodity = this.commodity;
    }
    if(!this.auditNo && !this.commodity) {
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}    
    this.$api.formatter.ensureListLoaded('workflow_masterBase','taxCode');                
  }
  public async onCreate(obj: Common.Price) {
    if(this.params != null && this.params.priceType != null && this.params.priceType != Common.PriceTypes.None) obj.priceType = this.params.priceType;
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.currency = this.tenantSettings.currencyCode;
    if (this.popup && this.commodity) obj.commodity = this.commodity;        
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Price):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public enabledPrice(no:number, item:Common.Price):boolean{
    if(no >= 1 && item.minimumQuantity1 == 0) return false;
    if(no >= 2 && item.minimumQuantity2 == 0) return false;
    if(no >= 3 && item.minimumQuantity3 == 0) return false;
    if(no >= 4 && item.minimumQuantity4 == 0) return false;
    if(no >= 5 && item.minimumQuantity5 == 0) return false;
    if(no >= 6 && item.minimumQuantity6 == 0) return false;
    if(no >= 7 && item.minimumQuantity7 == 0) return false;
    if(no >= 8 && item.minimumQuantity8 == 0) return false;
    if(no >= 9 && item.minimumQuantity9 == 0) return false;
    return true;
  }
  public checkPriceType(item:Common.Price)
  {
    // const item = (this.$refs.mainList as Components.ListView).selected as Common.Price;
    // 商品の販売単価区分が「販売単価掛率」で販売単価が入力された場合、設定が反映されない警告メッセージを出力する
    if(item.priceType==Common.PriceTypes.SalesPlice && item.commodity && item.commodity.priceType!=Common.SalesPricingTypes.PriceMaster){
      this.$api.modal.showDialog('メッセージ','単価マスタの販売単価を有効にするには、指定した商品の販売単価区分を「単価マスタ」に設定してください。',true);
    }
    if(item.priceType==Common.PriceTypes.SalesPlice && item.counterpart.counterpartType!=Common.CounterpartTypes.Customer) item.counterpart = null;
    if(item.priceType==Common.PriceTypes.PurchasePrice && item.counterpart.counterpartType!=Common.CounterpartTypes.Supplier) item.counterpart = null;
  }
}
</script>
